import { Component, HostBinding, Input } from '@angular/core';

/**
 * DOVE-2667 item exceptions — the driver's comment on an item exception, shown under the exception
 * status on the order items tables. Internal only (not exposed on the client portal).
 */
@Component({
	selector: 'app-order-item-exception-comment',
	template: '{{ comment }}'
})
export class OrderItemExceptionCommentComponent {
	@Input({ required: true }) comment!: string;

	@HostBinding('class') readonly hostClass = 'order-item-exception-comment block text-sm text-600 mt-1';
}
